
    import './styles.scoped.css';
    export default {
  "wrapper": "_wrapper_1qwnc_3",
  "label-wrapper": "_label-wrapper_1qwnc_10",
  "content": "_content_1qwnc_15",
  "description": "_description_1qwnc_21",
  "description-bottom-padding": "_description-bottom-padding_1qwnc_26",
  "label": "_label_1qwnc_10",
  "label-disabled": "_label-disabled_1qwnc_34",
  "description-disabled": "_description-disabled_1qwnc_35",
  "control": "_control_1qwnc_39",
  "outline": "_outline_1qwnc_42"
};
  